import React from "react";

const Footer = () => {
  return (
    <div className="footer-text">
      <span>© 2026 GLOBE TELECOM, INC.</span>
    </div>
  );
};

export default Footer;
